// frontend/src/config/payments.js
//
// Single source of truth for payment/currency configuration on the frontend.
//
// The platform currently operates India-only: Stripe is disabled and the only
// supported currency is INR (₹), which routes to Razorpay. Pages import these
// constants instead of hard-coding currency lists, so re-enabling multi-currency
// + Stripe later is a one-place change here (plus STRIPE_ENABLED / supported
// currencies on the backend).
//
// To restore the previous multi-currency behaviour:
//   export const SUPPORTED_CURRENCIES = ['USD', 'EUR', 'GBP', 'INR'];
//   export const DEFAULT_CURRENCY = 'USD';
//   export const STRIPE_ENABLED = true;

export const SUPPORTED_CURRENCIES = ['INR'];
export const DEFAULT_CURRENCY = 'INR';
export const STRIPE_ENABLED = false;

// Convenience: true when a currency selector should be shown at all.
export const SHOW_CURRENCY_SELECTOR = SUPPORTED_CURRENCIES.length > 1;
